<template>
    <b-media tag="li" class="p-2 mb-3 border">
        <template #aside>
            <b-img :src="value.PictureDetails.GalleryURL" blank-color="#abc" width="64" alt="placeholder"></b-img>
        </template>
        <div class="d-flex justify-content-between">
            <div>
                <small>{{ value.SKU }}</small><br>
            </div>
            <div>
                <small>
                    <slot name="link">
                        <a :href="value.ListingDetails.ViewItemURL" target="_blank">eBayで編集</a>
                        <br>
                        <a href="#" @click="onClickCopy(value)">コピー出品</a>
                    </slot>
                </small>
            </div>
        </div>
        <h5 class="mt-0 mb-1">{{ value.Title }}</h5>
        <div class="d-flex justify-content-between">
            <div>
                <small>{{ trans.labels['listings.listing_type.' + value.ListingType] }}</small><br>
                <h5 class="mb-0">{{ value.SellingStatus.CurrentPrice['@currencyID'] }} {{ value.SellingStatus.CurrentPrice['#'] }}</h5>
            </div>
        </div>
        <template v-if="value.ListingType === 'Chinese'">
            <div class="d-flex justify-content-between mb-1">
                <div>
                    <small>{{ value.SellingStatus.BidCount || 0 }}件の入札</small>
                    <small>開始:{{ value.StartPrice['@currencyID'] }} {{ value.StartPrice['#'] }}</small>
                </div>
            </div>
            <div class="d-flex justify-content-between mb-1" v-if="value.BuyItNowPrice">
                <div>
                    <small>{{ trans.labels['listings.listing_type.FixedPriceItem'] }}</small><br>
                    <h5 class="mb-0">{{ value.BuyItNowPrice['@currencyID'] }} {{ value.BuyItNowPrice['#'] }}</h5>
                </div>
            </div>
        </template>
        <div class="d-flex justify-content-between mb-1">
            <div>
                <small>開始日時:{{ value.ListingDetails.StartTime | BaseDatetimeFormatter(timezone) }}</small>
                <small v-if="value.ListingDuration">({{ value.ListingDuration }})</small>
            </div>
        </div>
    </b-media>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: {},
        },
        timezone: {
            type: String,
            required: false,
            default: '-0800',
        },
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {}
    },
    async mounted() {
    },
    methods: {
        async listItem(item, provider) {
            let provider_type = null
            switch (provider) {
                case 'amazon':
                    provider_type = 'inventory'
                    break
                case 'ebay':
                    provider_type = 'store'
                    break
            }

            await this.$store
                .dispatch('item/list_item', { uuid: item.uuid, provider: provider, })
                .then((response) => {
//                    this.fetch()
                    this.$emit('sync')
                })
                .catch((error) => {
                })
        },
        async onClickCopy(item) {
            this.$emit('copy', item)
        },
    },
}
</script>

